<template>
  <div class="border-tp border-light-200 dark:border-dark-600" :style="{ '--duration': '150ms' }" ref="$container">
    <div class="grid grid-cols-2 px-2.5 gap-1 font-bold text-2xs" v-if="currentUser?.isAdmin && isStats && types.includes('stats')">
      <div class="p-1 rounded-md bg-royal-900/20">
        <IconBase name="cute/eye" :width="16" /> {{ (post as any).sentimentCount }} vues
      </div>
      <div class="p-1 rounded-md bg-royal-900/20">
        <IconBase name="cute/eye" :width="16" /> {{ -5 * Math.round((post as any).sentimentScore) }} score
      </div>
      <div class="p-1 rounded-md bg-royal-900/20">
        <IconBase name="cute/eye" :width="16" /> {{ Math.round((post as any).scoreCustom) }} total
      </div>
    </div>

    <TransitionGroup name="list-simple" tag="div" class="flex text-xs font-bold w-full" :class="[ size === 'md' ? 'space-x-3.5' : 'space-x-3' ]">
      
      <!-- <div class="grow" key="spacer" /> -->

      <!-- <div class="flex items-center cursor-pointer space-x-1.5 justify-center shrink-0 py-1 px-2.5" :class="[ hasCheered ? 'text-[#ffa417] dark:text-[#ffae43]' : '', post.owner === currentUser?._id ? 'pointer-events-none opacity-50' : '']" @click.stop="() => isAddCheers = !isAddCheers" key="cheer" v-if="types.includes('cheers')">
        <div class="relative">
          <IconBase :name="hasCheered || isAddCheers ? 'cute/party-fill' : 'cute/party'" :width="24" />
        </div>

        <NumberFlow :value="post.cheers.length" :locales="$i18n.locale" :format="{ notation: 'compact' }" :class="[ post.cheers.length > 0 ? '' : 'opacity-0 absolute pointer-events-none']" />
      </div> -->

      <div class="flex items-center cursor-pointer space-x-1.5 justify-center shrink-0 rounded-full" :class="[ reactionTypeCurrent === 'downvote' || isTempDownvote ? 'bg-ruby-700/20 text-ruby-500' : (reactionTypeCurrent === 'upvote' || isTempUpvote ? 'bg-cobra-700/20 text-cobra-500' : 'bg-light-600/20 dark:bg-dark-500/20') ]" key="upvotes" v-if="types.includes('votes')">
        <div class="relative size-8 flex items-center justify-center rounded-full" :class="[ reactionTypeCurrent === 'upvote' || isTempUpvote ? 'bg-cobra-400/20 dark:bg-cobra-700/20 text-cobra-500' : 'bg-light-600/20 dark:bg-dark-500/20 dark:text-dark-50 text-light-950', reactionTypeCurrent && reactionTypeCurrent !== 'upvote' || isTempDownvote ? 'opacity-20' : '']" @click="() => onVote('upvote')">
          <IconBase :name="'cute/upvote' + (reactionTypeCurrent === 'upvote' || isTempUpvote ? '-fill' : '')" class="-mt-0.5" :width="22" />
        </div>

        <NumberFlow :value="post.votes + (isTempUpvote && !reactionTypeCurrent ? 1 : (isTempDownvote && !reactionTypeCurrent ? -1 : 0))" :locales="$i18n.locale" :format="{ notation: 'compact' }" />

        <div class="relative size-8 flex items-center justify-center rounded-full" :class="[ reactionTypeCurrent === 'downvote' || isTempDownvote ? 'bg-ruby-500/20 dark:bg-ruby-700/20 text-ruby-500' : 'bg-light-600/20 dark:bg-dark-500/20 dark:text-dark-50 text-light-950', reactionTypeCurrent && reactionTypeCurrent !== 'downvote' || isTempUpvote ? 'opacity-20' : '' ]" @click="() => onVote('downvote')">
          <IconBase :name="'cute/upvote' + (reactionTypeCurrent === 'downvote' || isTempDownvote ? '-fill' : '')" class="rotate-180 -mb-0.5" :width="22" />
        </div>
      </div>

      <div class="flex items-center cursor-pointer space-x-1.5 justify-center shrink-0" :class="[ hasLiked ? 'text-flamingo-600' : '']" @click.stop="onLike" key="like" v-if="types.includes('likes')">
        <div class="relative">
          <IconBase name="cute/heart-fill" class="absolute top-0 left-0" :class="[ hasLiked ? 'animate-heart-2' : 'opacity-0' ]" :width="size === 'md' ? 26 : 22" />

          <IconBase :name="hasLiked ? 'cute/heart-fill' : 'cute/heart'" :class="[ hasLiked ? 'animate-heart' : '' ]" :width="size === 'md' ? 26 : 22" />
        </div>

        <NumberFlow :value="post.reactions.length + (isTempLike === true ? 1 : (isTempLike === false ? -1 : 0))" :locales="$i18n.locale" :format="{ notation: 'compact' }" :class="[ post.reactions.length > 0 || isTempLike ? '' : 'opacity-0 absolute pointer-events-none']" />
      </div>

      <NuxtLink @click.stop :to="{ query: { ...route.query, post: post._id, isComments: 'true' } }" class="flex items-center space-x-1.5 justify-center shrink-0" key="comment" v-if="type === 'post' && types.includes('comments')">
        <IconBase name="cute/comment-2" :width="size === 'md' ? 28 : 24" />

        <NumberFlow :value="post.posts.length" :locales="$i18n.locale" :format="{ notation: 'compact' }" :class="[ post.posts.length > 0 ? '' : 'opacity-0 absolute pointer-events-none']" />
      </NuxtLink>
      <div class="flex items-center space-x-1.5 justify-center shrink-0 cursor-pointer" key="comment-reply" @click.stop="() => emit('answer')" v-else-if="types.includes('comments')">
        <IconBase name="cute/comment-2" :width="size === 'md' ? 28 : 24" />

        <NumberFlow :value="post.posts.length" :locales="$i18n.locale" :format="{ notation: 'compact' }" :class="[ post.posts.length > 0 ? '' : 'opacity-0 absolute pointer-events-none']" />
      </div>

      <NuxtLink :to="{ query: { ...(route.query ?? {}), user: owner.username }}" class="flex items-center space-x-1.5 bg-light-600/20 dark:bg-dark-500/20 rounded-full pr-2.5 h-6 self-center" v-if="owner && types.includes('user')">
        <UserPicture 
          :user="owner"
          is-link
          size="2xs"
          class="shrink-0"
        />

        <div class="grow flex items-baseline font-medium space-x-1.5">
          <p class="text-sm font-medium break-all line-clamp-1 leading-none">{{ owner.name }}</p>
          <p class="text-xs font-normal break-all line-clamp-1 shrink text-charcoal-600 leading-none" v-if="(owner.pronouns ?? []).length > 0">{{ owner.pronouns.join('/') }}</p>
        </div>
      </NuxtLink>

      <UserPicture 
        :user="owner"
        is-link
        size="xs"
        class="self-center"
        v-if="owner && types.includes('user-sm')"
      />

      <div class="font-medium leading-tight line-clamp-1 self-center text-charcoal-500 shrink-0 dark:text-dark-400" v-if="post.createdAt && types.includes('date')">
        {{ dayjs(post?.createdAt).fromNow(true) }}
      </div>

      <!-- <div class="flex items-center space-x-1.5 justify-center shrink-0 py-1 cursor-pointer opacity-5" key="reply" @click.stop="() => isStats = !isStats" v-if="currentUser?.isAdmin && types.includes('stats')">
        <IconBase :name="isStats ? 'cute/star-fill' : 'cute/star'" :width="24" />
      </div> -->
      
      <div class="grow" key="spacer" />

      <div class="flex items-center space-x-1.5 justify-center shrink-0 cursor-pointer rounded-full active:bg-charcoal-400/20 hover:bg-charcoal-400/20" :class="[ size === 'md' ? 'size-8' : 'size-6' ]" @click.stop="() => onContextMenu()" key="menu" v-if="types.includes('menu')">
        <IconBase name="cute/dots-h" :width="size === 'md' ? 26 : 18" />
      </div>
    </TransitionGroup>

    <!-- <Transition name="fade">
      <div
        class="p-3 mb-2 bg-[#ffe6b3] dark:bg-[#e99d3a] text-[#db6408] dark:text-[#ffe8c5] space-y-1.5 relative"
        v-if="(cheers.length > 0 || (isAddCheers && (post.owner !== currentUser?._id || hasCheered))) && !post.parent && !isHideCheers && types.includes('cheers')"
      >
        <template v-if="isAddCheers && post.owner !== currentUser?._id && !hasCheered">
          <div class="flex items-center text-xs font-bold relative z-10">
            <p class="grow flex items-center space-x-1">
              <IconBase name="cute/party-fill" :width="16" />
              <span>{{ $t('components.Cheers.post.action') }}</span>
            </p>

            <ButtonLink size="xs" :to="{ query: { ...(route?.query ?? {}), subscribe: true }}">{{ $t('components.Cheers.post.remaining', { count: currentUser?.cheers ?? 0, max: currentUser?.isSubscriber ? 3 : 1}) }}</ButtonLink>
          </div>

          <div class="overflow-auto -mx-3 px-3 !-mb-3 pb-3 no-scrollbar relative z-10" @touchstart="() => emit('scroll-start')" @touchend="() => emit('scroll-end')">
            <div class="flex items-center gap-x-1">
              <button class="flex items-center justify-center rounded-lg bg-[#ffcd92] dark:bg-[#ffdcb0] size-11 shrink-0 translate-y-2 opacity-0 cursor-pointer animate-appear"  :style="{ animationDelay: `${i * 45}ms` }" v-for="(reaction, reactionId, i) in CHEERS" @click.stop="() => cheersSelected = reactionId">
                <ImageEmoji :name="reaction.name" size="sm" class="size-7" :class="[ cheersSelected === reactionId ? '' : (cheersSelected ? 'opacity-30' : '') ]" />

                <div class="absolute -bottom-0.5 -right-0.5 bg-[#ffa417] dark:bg-[#ffae43] text-white rounded-full flex items-center justify-center size-4 z-20 pointer-events-none" v-if="cheersSelected === reactionId">
                  <IconBase name="cute/check-fill" :width="8" />
                </div>
              </button>

              <div class="shrink-0 w-12 h-0.5" />
            </div>
          </div>

          <ButtonBase is-full size="2xs" class="relative z-10" @click.stop="() => onReact(cheersSelected)" :is-loading="isLoading" v-if="cheersSelected">
            {{ $t('actions.send') }}
          </ButtonBase>
          <div class="bg-[#ffcd92] dark:bg-[#ffdcb0] dark:text-[#db6408] py-4 px-4 leading-snug text-sm font-medium rounded-lg relative z-10" v-else-if="!(currentUser?.journey ?? []).includes('info-cheers')">
            {{ $t('components.Cheers.post.info') }}

            <div class="absolute top-0 right-0 flex items-center p-2 cursor-pointer" @click.stop="() => userStore.updateJourney('info-cheers')">
              <IconBase name="cute/cross-fill" :width="16" />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="flex items-center flex-wrap gap-y-1.5 gap-x-1.5 -mx-0.5 relative z-10">
            <div class="relative" v-for="reaction in cheers">
              <UserPicture :user="reaction.owner" is-link size="base" is-hide-badges />

              <div class="absolute bottom-0 -right-1 pointer-events-none bg-white size-[1.35rem] rounded-full flex items-center justify-center">
                <ImageEmoji :name="reaction.reaction.name" size="sm" class="size-[0.95rem]" />
              </div>
            </div>

            <div class="shrink-0 size-12 border-2 border-light-950/30 text-light-950/30 dark:border-white/30 dark:text-white/30 rounded-full flex items-center justify-center cursor-pointer" @click.stop="() => isAddCheers = true" v-if="post.owner !== currentUser?._id && !hasCheered">
              <IconBase name="cute/plus-fill" :width="16" />
            </div>
          </div>
        </template>

        <div class="pattern-confetti absolute top-0 !m-0 left-0 w-full h-full pointer-events-none" />

        <div class="absolute -top-[0.37rem] inline-block border-b-[6px] !border-b-[#ffe6b3] dark:!border-b-[#e99d3a] !m-0" :style="{ width: 0, height: 0, borderRight: '6px solid transparent', borderLeft: '6px solid transparent' }" />
      </div>
    </Transition> -->
  </div>
</template>

<script lang="ts" setup>
import ContextStore from '@/store/context'
import NumberFlow from '@number-flow/vue'
import { Post, Reaction, User } from '@/classes'
import { CHEERS } from '@/static/reactions'
import UserStore from '@/store/user'
import ReactionStore from '@/store/reactions'
import WindowStore from '@/store/window'
import { ImpactStyle } from '@capacitor/haptics'
import GroupsStore from '@/store/groups'
import EventStore from '@/store/events'
import UsersStore from '@/store/users'
import dayjs from 'dayjs'

const props = withDefaults(defineProps<{
  post: Post
  parent?: Post | null
  size?: 'base' | 'md'
  types?: ('likes' | 'comments' | 'date' | 'cheers' | 'menu' | 'stats' | 'user' | 'user-sm' | 'votes')[]
  isHideCheers?: boolean
  type?: 'post' | 'post-main' | 'comment' | 'comment-reply'
}>(), {
  parent: null,
  size: 'base',
  types: () => [ 'likes', 'comments', 'cheers', 'menu', 'stats', 'user' ],
  isHideCheers: false,
  type: 'post'
})

const emit = defineEmits<{
  (e: 'answer'): void
  (e: 'like'): void
  (e: 'scroll-start'): void
  (e: 'scroll-end'): void
}>() 

const { post, parent } = toRefs(props)
const userStore = UserStore()
const groupsStore = GroupsStore()
const eventStore = EventStore()
const usersStore = UsersStore()
const reactionsStore = ReactionStore()
const windowStore = WindowStore()
const { currentUser } = storeToRefs(userStore)

const router = useRouter()

const hasLiked = computed(() => (post.value.reactions.some(reaction => reaction.value === 'like' && reaction.owner === currentUser.value?._id) && isTempLike.value !== false) || isTempLike.value === true)
const isTempLike: Ref<boolean | null> = ref(null)

const route = useRoute()
const isLoading = ref(false)
const cheersSelected: Ref<keyof typeof CHEERS | ''> = ref('')

const onLike = async () => {
  if (!post.value || isLoading.value || !currentUser.value) return

  emit('like')

  isLoading.value = true

  if (hasLiked.value) {
    isAddCheers.value = false
    isTempLike.value = false

    await reactionsStore.remove({
      value: 'like',
      type: 'post',
      id: post.value._id,
      // ...(isChildren ? {
      //   root: parent.value?._id ?? post.value._id
      // } : {
        root: props.type === 'post-main' ? post.value._id : (props.type === 'comment-reply' ? post.value.parent : (parent.value?.parent ?? post.value._id))
      // })
    })
  } else {
    vibrate(ImpactStyle.Light)

    isAddCheers.value = Math.random() > (currentUser.value.cheers > 0 ? 0.4 : 0.75) ? true : false
    
    isTempLike.value = true

    useNuxtApp().$amplitude.logEvent(post.value.parent ? 'Comment_React' : (post.value.type === 'story' ? 'Story_React' : 'Post_React')), {
      type: 'like',
      source: route.fullPath
    }

    await reactionsStore.create({
      value: 'like',
      type: 'post',
      id: post.value._id,
      root: props.type === 'post-main' ? post.value._id : (props.type === 'comment-reply' ? post.value.parent : (parent.value?.parent ?? post.value._id))
    })
  }

  isTempLike.value = null
  isLoading.value = false
}

const isTempUpvote = ref(false)
const isTempDownvote = ref(false)

const reactionTypeCurrent = computed(() => post.value.reactions.find(r => r.owner === currentUser.value?._id)?.value ?? '')

const onVote = async (type: 'upvote' | 'downvote') => {
  if (!post.value || isLoading.value || !currentUser.value) return

  emit('like')

  isLoading.value = true

  if (type === reactionTypeCurrent.value) {
    await reactionsStore.remove({
      value: type,
      type: 'post',
      id: post.value._id,
      root: props.type === 'post-main' ? post.value._id : (props.type === 'comment-reply' ? post.value.parent : (parent.value?.parent ?? post.value._id))
    })
  } else {
    if (type === 'upvote') {
      isTempUpvote.value = true
    } else {
      isTempDownvote.value = true
    }

    vibrate(ImpactStyle.Light)

    await reactionsStore.create({
      value: type,
      type: 'post',
      id: post.value._id,
      root: props.type === 'post-main' ? post.value._id : (props.type === 'comment-reply' ? post.value.parent : (parent.value?.parent ?? post.value._id))
    })

    isTempDownvote.value = false
    isTempUpvote.value = false
  }

  isLoading.value = false
}

const isAddCheers = ref(false)
const hasCheered = computed(() => post.value.cheers.some(reaction => reaction.owner === currentUser.value?._id))

watch(isAddCheers, () => {
  if (!isAddCheers.value) {
    cheersSelected.value = ''
  }
})

interface CheersPopulated extends Omit<Reaction, 'owner'>{
  reaction: typeof CHEERS[keyof typeof CHEERS]
  owner: User | null
}

const cheers = computed(() => post.value.cheers.map(reaction => {

  return {
    ...reaction,
    reaction: CHEERS[reaction.value],
    owner: usersStore.getItem(reaction.owner)
  } as CheersPopulated
}).filter((r: CheersPopulated) => r.owner).sort((a, b) => Number(new Date(b.createdAt)) - Number(new Date(a.createdAt))))

const onReact = async (reaction: keyof typeof CHEERS | '') => {
  if (!post.value || !currentUser.value || !reaction) return

  if (!currentUser.value.isOnboarded2) {
    router.push({ query: { ...(route?.query ?? {}), complete: 'true' } })
    return
  } 

  if ((currentUser.value.cheers ?? 0) <= 0) {
    router.push({ query: { ...(route?.query ?? {}), subscribe: 'true' } })
    return
  }

  isLoading.value = true

  vibrate(ImpactStyle.Light)

  useNuxtApp().$amplitude.logEvent('Post_ReactSuper'), {
    type: reaction,
    source: route.fullPath
  }

  await reactionsStore.create({
    value: reaction,
    type: 'post-super',
    id: post.value._id
  })

  // windowStore.addConfetti({
  //   emojiSize: 100,
  //   confettiRadius: 10,
  //   confettiNumber: 10,
  //   emojis: [ CHEERS[reaction].emoji ],
  // })

  isAddCheers.value = false
  isLoading.value = false
}

// STATS

const isStats = ref(false)

// CONTEXT

const { showContextMenu } = ContextStore()

const event = computed(() => props.post?.attachments?.event ? eventStore.getItem(props.post?.attachments.event) : null)
const group = computed(() => props.post?.group ? groupsStore.getItem(props.post.group) : null)
const owner = computed(() => props.post?.owner ? usersStore.getItem(props.post.owner) : null)

const onContextMenu = () => {
  showContextMenu(
    {
      post: props.post ?? undefined,
      postParent: props.parent ?? undefined,
      group: group.value ?? undefined,
      event: event.value ?? undefined,
      user: owner.value ?? undefined,
    },
    ['post'],
    {
      onCheers: () => isAddCheers.value = true
    }
  )
}
</script>

<style scoped>
.animate-heart {
  animation: heart 0.3s cubic-bezier(0.43, 0.22, 0.32, 1.44)  forwards;
}

@keyframes heart {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.35) rotate(2deg);
  }
  100% {
    transform: scale(1);
  }
}

.animate-heart-2 {
  animation: heart-2 0.3s ease-out forwards;
  animation-delay: 0s;
}

@keyframes heart-2 {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    transform: scale(2);
    opacity: 0;
  }
}

.animate-appear {
  animation: animate-appear 0.2s ease-out forwards;
}

@keyframes animate-appear {
  0% {
    transform: translateY(0.5rem);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.pattern-confetti {
  background-image: url("data:image/svg+xml,%3Csvg width='52' height='26' viewBox='0 0 52 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffa417' fill-opacity='0.2'%3E%3Cpath d='M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

.dark .pattern-confetti {
  fill: #ff8d3b;
  background-image: url("data:image/svg+xml,%3Csvg width='52' height='26' viewBox='0 0 52 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffe9c4' fill-opacity='0.15'%3E%3Cpath d='M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E") !important;
}


</style>